import { render, staticRenderFns } from "./EmpresaUploadVerificacao.vue?vue&type=template&id=7c8653ed&lang=pug"
import script from "./EmpresaUploadVerificacao.vue?vue&type=script&lang=js"
export * from "./EmpresaUploadVerificacao.vue?vue&type=script&lang=js"
import style0 from "./EmpresaUploadVerificacao.vue?vue&type=style&index=0&id=7c8653ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports